import * as React from 'react';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import {
  Case4CauseTenPercent,
  Case4CauseTwentyPercent,
  Case4CauseFivePercent,
} from './case4CausePercentageComponents';
import { getBottles } from './case4CauseHelpers';

export function Case4CauseBottlesBase({
  cartQty,
  isDiscount20,
  flags,
  isDiscount10,
  isDiscount5,
}: {
  cartQty: number;
  isDiscount20: boolean;
  flags?: LDFlagSet;
  isDiscount10?: boolean;
  isDiscount5?: boolean;
}) {
  const bottles = getBottles(cartQty);

  return bottles.map((img, index) => (
    <span key={`${index}${index}${isDiscount20}`} className="ToastBottle">
      <img src={img} alt="" />
      <Case4CauseFivePercent
        imgPath={img}
        flags={flags}
        isDiscount20={isDiscount20}
        isDiscount10={isDiscount10}
        isDiscount5={isDiscount5}
        index={index}
      />
      <Case4CauseTenPercent
        imgPath={img}
        flags={flags}
        isDiscount20={isDiscount20}
        isDiscount5={isDiscount5}
      />
      <Case4CauseTwentyPercent
        imgPath={img}
        flags={flags}
        isDiscount20={isDiscount20}
      />
    </span>
  ));
}

export const Case4CauseBottles = React.memo(Case4CauseBottlesBase);
